export default __webpack_public_path__ + "static/media/GF.6455f145.svg";